import { z } from 'zod';
import { DocumentTypesEnum, expectType, zDocument } from './model.js';
import { reverseKeys } from './util/reverseKeys.js';
export const ReportReasonsLookup = {
    offensive: 'Offensive Content',
    spam: 'Spam'
};
export const ReportReasonsEnum = z.nativeEnum(reverseKeys(ReportReasonsLookup));
export const ReportReasonsFilterLookup = { ...ReportReasonsLookup, all: 'All' };
export const zReport = zDocument.extend({
    type: z.literal('report'),
    document: z.string(),
    documentType: DocumentTypesEnum.or(z.literal('')),
    reporter: z.string(),
    user: z.string(),
    reason: ReportReasonsEnum
});
export const zTotalReportsFields = z.object({
    totalReports: z.number()
});
expectType({});
expectType({});
export const EmptyNewReport = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    document: '',
    documentType: '',
    type: 'report',
    reporter: '',
    user: '',
    reason: 'offensive'
};
export const EmptyReport = EmptyNewReport;
